import React from 'react'
import EditIcon from '@mui/icons-material/Edit'

export interface MotiveEditProps {
  motiveId: number
}

export default function MotiveEdit(props: MotiveEditProps) {
  const baseUrl = 'https://artist.artbox.one/artist/motivedb/motiveEdit/'

  if (process.env.SHOW_CMS_LINKS == '1' && props.motiveId > 0) {
    return (
      <div className="container">
        <div className="row">
          <div className="col">
            <a href={baseUrl + props.motiveId} rel="noreferrer" target="_blank">
              <EditIcon />
            </a>
          </div>
        </div>
      </div>
    )
  } else {
    return <></>
  }
}
